import resetReduxAction from 'modules/redux/actions/reset'
import { hasHeaderBannerSelect } from 'modules/headerBanner/selectors/hasHeaderBanner/index.js'
import { HEADER_BANNER_DOMAIN } from 'modules/headerBanner/constants/index.js'

export function closeHeaderBannerAction () {
  return (dispatch, getState) => {
    if (!hasHeaderBannerSelect(getState())) {
      return
    }

    dispatch(
      resetReduxAction({
        type: 'CLOSE_HEADER_BANNER',
        payload: {
          path: HEADER_BANNER_DOMAIN
        }
      })
    )
  }
}
